@if (contentTpl) {
  <ng-container [ngTemplateOutlet]="contentTpl" />
} @else {
  <div class="badge-container">
    @if (iconName && !iconTmpl) {
      <rt-icon size="small-xx" [name]="iconName" />
    }
    @if (iconTmpl && !iconName) {
      <ng-container [ngTemplateOutlet]="iconTmpl" [ngTemplateOutletContext]="iconTmplContext()" />
    }
    <span>{{ text() }}</span>
  </div>
}
